// http://insight-direct.staging.memcachier.com:8080/api/v2 - Analytics staging
// https://insight.memcachier.com/api/v2 - Analytics production
// http://localhost:8080/api/v2 - local stack
export const API_URL: string = process.env.NODE_ENV === "development" ? "http://localhost:8080/api/v2" : "/api/v2";
